$('[data-toggle="collapse"]').on('click', function () {

    let objA = $(this);
    let objDiv = $(`#${objA.attr('data-target')}`);
    const icon = $(objA).find('i');

    if (icon) {
        if (objDiv.css('display') === 'none') {
            icon.addClass('rotate-90');
        } else {
            icon.removeClass('rotate-90');
        }
    }

    $(objDiv).slideToggle('fast', function () {
    });

    return false;
});
